import { render, staticRenderFns } from "./smsVerification.vue?vue&type=template&id=b5840976&scoped=true"
import script from "./smsVerification.vue?vue&type=script&lang=js"
export * from "./smsVerification.vue?vue&type=script&lang=js"
import style0 from "./smsVerification.vue?vue&type=style&index=0&id=b5840976&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b5840976",
  null
  
)

export default component.exports